import React, { useState, useEffect, useCallback } from 'react';

const partners = [
  { name: 'Queensland Government', logo: '/images/logos_0000_QueenslandGov.png' },
  { name: 'Alliance', logo: '/images/logos_0001_Alliance.png' },
  { name: 'Cricks', logo: '/images/logos_0002_Cricks.png' },
  { name: 'Youi', logo: '/images/logos_0003_Youi.png' },
  { name: 'Sea FM', logo: '/images/logos_0004_SeaFM.png' },
  { name: 'Mix FM', logo: '/images/logos_0005_MixFM.png' },
  { name: 'Bakers Delight', logo: '/images/logos_0007_BakersDelight.png' },
  { name: 'Australian Government', logo: '/images/logos_0008_AustGov.png' },
  { name: 'Halcol', logo: '/images/logos_0009_Halcol.png' },
  { name: 'Domayne', logo: '/images/logos_0010_Domayne.png' },
  { name: 'Commonwealth Bank', logo: '/images/logos_0013_CommonwealthBank.png' },
  { name: 'QEBS', logo: '/images/logos_0016_QEBS.png' },
  { name: 'Harvey Norman', logo: '/images/logos_0017_HarveyNorman.png' },
  { name: 'Cairns Taipans', logo: '/images/Cairns Taipans Logo_for website.png' },
  { name: 'Star 102.7', logo: '/images/Star1027_RadioAppMedium.png' },
  { name: 'Sunshine Coast Council', logo: '/images/scc-176.png' },
  { name: 'Alex Rotary', logo: '/images/AlexRotaryLogo.png' },
];

const VISIBLE = { sm: 2, md: 3, lg: 4 };

const useVisibleCount = () => {
  const [count, setCount] = useState(VISIBLE.lg);
  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w >= 1024) setCount(VISIBLE.lg);
      else if (w >= 768) setCount(VISIBLE.md);
      else setCount(VISIBLE.sm);
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  return count;
};

const PartnershipsCarousel = () => {
  const visibleCount = useVisibleCount();
  const [startIndex, setStartIndex] = useState(0);
  const maxStart = Math.max(0, partners.length - visibleCount);

  useEffect(() => {
    if (startIndex > maxStart) setStartIndex(maxStart);
  }, [visibleCount, maxStart, startIndex]);

  const goPrev = useCallback(() => setStartIndex((i) => Math.max(0, i - 1)), []);
  const goNext = useCallback(() => setStartIndex((i) => Math.min(maxStart, i + 1)), [maxStart]);

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-ifys-blue text-center mb-10 md:mb-12 tracking-tight">
          Our Partnerships
        </h2>

        <div className="flex items-center justify-center gap-2 md:gap-4">
          <button
            type="button"
            onClick={goPrev}
            disabled={startIndex === 0}
            className="flex-shrink-0 p-2 rounded-full text-gray-600 hover:text-ifys-blue hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 focus:outline-none focus:ring-2 focus:ring-ifys-blue focus:ring-offset-2 transition-all duration-200 ease-smooth hover:scale-110 active:scale-95"
            aria-label="Previous partners"
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <div className="flex items-center justify-center flex-1" style={{ gap: '2rem' }}>
            {partners.slice(startIndex, startIndex + visibleCount).map((partner) => (
              <div
                key={partner.name}
                className="flex flex-col items-center"
                style={{ flex: `0 0 ${Math.floor(80 / visibleCount)}%` }}
              >
                <div className="h-40 flex items-center justify-center w-full">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    loading="lazy"
                    className="object-contain max-h-full max-w-full"
                  />
                </div>
                <span className="text-gray-500 text-sm text-center mt-3 leading-tight">{partner.name}</span>
              </div>
            ))}
          </div>

          <button
            type="button"
            onClick={goNext}
            disabled={startIndex >= maxStart}
            className="flex-shrink-0 p-2 rounded-full text-gray-600 hover:text-ifys-blue hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 focus:outline-none focus:ring-2 focus:ring-ifys-blue focus:ring-offset-2 transition-all duration-200 ease-smooth hover:scale-110 active:scale-95"
            aria-label="Next partners"
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default PartnershipsCarousel;
